<template>
  <div class="runmax_title">
    <div class="title_main d-flex">
      <div class="title_left d-flex">
        <p class="">
          <img :src="testInfo0.proj_icon" alt="" height="80" class="pro-icon" />
        </p>
        <ul class="game-info">
          <li class="sub-title pt-0">{{ testInfo0.proj_name }}</li>
          <li class="mt-2">Version:{{ testInfo0.game_version }}</li>
          <li>Package:{{ testInfo0.pkgname }}</li>
        </ul>
      </div>
      <div class="title_right px-5 me-5 d-flex flex-grow-1 justify-content-between">
        <div class="d-flex">
          <p class="img_style">
            <img src="@/assets/icon/phone.png" alt="" height="36" />
          </p>
          <ul class="ps-3">
            <li class="sub-title">{{ testInfo0.device }}</li>
            <li class="mt-2">CPU:{{ testInfo0.cpu_name }}</li>
            <li>GPU:{{ testInfo0.gpu_name }}</li>
          </ul>
        </div>
        <div class="d-flex">
          <p class="img_style">
            <img src="@/assets/icon/user.png" alt="" height="36" />
          </p>
          <ul class="ps-3">
            <li class="sub-title">创建者</li>
            <li class="mt-2">{{ testInfo0.tester }}</li>
          </ul>
        </div>
        <div class="d-flex">
          <p class="img_style">
            <img src="@/assets/icon/duration.png" alt="" height="36" />
          </p>
          <ul class="ps-3">
            <li class="sub-title">时长</li>
            <li class="mt-2">{{ testInfo0.duration }}</li>
          </ul>
        </div>
        <div class="d-flex">
          <p class="img_style">
            <img src="@/assets/icon/update-time.png" alt="" height="36" />
          </p>
          <ul class="ps-3">
            <li class="sub-title">上传时间</li>
            <li class="mt-2">{{ testInfo0.timestamp_start }}</li>
          </ul>
        </div>
      </div>
    </div>
    <p class="title_end mt-2">
      测试场景：<span>{{ testInfo0.map_name }}</span>
    </p>
  </div>
</template>

<script>
import {ref, computed} from 'vue'
import {useRoute} from 'vue-router'
import axios from 'axios'

export default {
  props: {
    data: Object,
  },

  setup(props) {
    let route = useRoute(),
      testInfo0 = computed(() => props?.data?.['测试信息'] || {})

    return {testInfo0}
  }
}
</script>

<style scoped>
.runmax_title {
  background: linear-gradient(90deg, #516ce9, #8d87db);
  box-shadow: 0 .04rem .1rem rgba(83, 73, 197, .3);
  color: #e4e7fb;
}

.runmax_title ul {
  list-style: none;
}

.title_main {
  padding: 24px 0 0 24px;
}

.pro-icon {
  border-radius: 10px;
}

.game-info {
  padding: 0 24px 0 12px;
  border-right: 1px solid #e4e7fb;
}

.sub-title {
  font-weight: bold;
  color: #fff;
  font-size: 20px;
  padding-top: 6px;
}

.img_style {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  border-radius: 100%;
  background: #4c52d5;
  flex-shrink: 0;
}

.title_end {
  height: 50px;
  line-height: 49px;
  padding-left: 24px;
  border-top: 1px solid hsla(0, 0%, 100%, .1);
  background: rgba(76, 82, 213, .3);
  color: #fff;
}
</style>